import { API_ADMIN_URL } from '../../../config/constants';
import { postRequest } from '../../API';

/*********************************************************
 * Function Name : list
 * Description   : Get paginated user request list
 *********************************************************/
export const list = async (options) => {
    try {
        const params = {
            url: `${API_ADMIN_URL}accounts/request/list`,
            postData: options,
        };
        const res = await postRequest(params);
        if (res.status === true || res.status === 200) {
            return { status: true, result: res?.data?.response?.result, count: res?.data?.response?.count };
        } else {
            return { status: false, message: res?.response?.data?.statusMessage };
        }
    } catch (error) {
        return { status: false, message: 'Under Maintenance, Please try after some time.' };
    }
};

/*********************************************************
 * Function Name : changeStatus
 * Description   : BDM / Deployment approve or reject a request
 *********************************************************/
export const changeStatus = async (options) => {
    try {
        const params = {
            url: `${API_ADMIN_URL}accounts/request/change-status`,
            postData: options,
        };
        const res = await postRequest(params);
        if (res.status === true || res.status === 200) {
            return { status: true, result: res?.data?.response?.result };
        } else {
            return { status: false, message: res?.response?.data?.statusMessage };
        }
    } catch (error) {
        return { status: false, message: 'Under Maintenance, Please try after some time.' };
    }
};
